import { render } from "./AposAreaWidget.vue?vue&type=template&id=5b4a5b48&scoped=true"
import script from "./AposAreaWidget.vue?vue&type=script&lang=js"
export * from "./AposAreaWidget.vue?vue&type=script&lang=js"

import "./AposAreaWidget.vue?vue&type=style&index=0&id=5b4a5b48&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b4a5b48"],['__file',"area/ui/apos/components/AposAreaWidget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b4a5b48"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b4a5b48', __exports__)) {
    api.reload('5b4a5b48', __exports__)
  }
  
  module.hot.accept("./AposAreaWidget.vue?vue&type=template&id=5b4a5b48&scoped=true", () => {
    api.rerender('5b4a5b48', render)
  })

}


export default __exports__